export default "__VITE_ASSET__16676641__"